<div class="skeleton" [ngStyle]="styles" [ngClass]="theme">
  <ng-content></ng-content>
</div>
